import mini from './src/miniProgram.js'
import register from './src/register.js'

export default Object.assign(
	{},
	mini,
	register
)



// WEBPACK FOOTER //
// ./src/lib/weixin/index.js